<ChapterNav params="{params}" segment="pruefung" />

{#if ch}
  <section class="section" id="chapter">
    <div class="container pt-5">
      <div class="has-text-centered mt-5 mb-5">
        <h1 class="is-size-3">
          Platzreifeprüfung - Kapitel:
          {@html ch.title}
        </h1>
      </div>
      <div
        class="{!videoPlayed || !allRulesRead || (examProgressData && examProgressData[ch.slug] == true) ? 'disabled' : ''}"
      >
        {#if !videoPlayed || !allRulesRead}
          <div class="columns mt-6">
            <article
              class="disabled-notice column message is-warning is-three-fifths-tablet is-offset-one-fifth-tablet"
            >
              <div class="message-header">
                <p>Hinweis</p>
              </div>
              <div class="message-body">
                Du kannst die Prüfung erst antreten, nachdem du das Video
                angesehen und die Regeln durchgelesen hast.
              </div>

              <div class="message-footer has-text-centered">
                {#if !videoPlayed}
                  <button
                    class="button"
                    on:click="{() => push('/platzreife/' + ch.slug + '/video')}"
                  >
                    <span>Zum Video</span>
                  </button>
                {:else}
                  <button
                    class="button"
                    on:click="{() => push('/platzreife/' + ch.slug + '/regeln')}"
                  >
                    <span>Zu den Regeln</span>
                  </button>
                {/if}
              </div>
            </article>
          </div>
        {:else if examProgressData && examProgressData[ch.slug] == true}
          <div class="columns mt-6">
            <article
              class="disabled-notice column message is-success is-three-fifths-tablet is-offset-one-fifth-tablet"
            >
              <div class="message-header">
                <p>Hinweis</p>
              </div>
              <div class="message-body">
                Du hast diese Prüfung erfolgreich abgeschlossen und kannst die
                Fragen nicht erneut einsehen.
              </div>

              <div class="message-footer has-text-centered">
                <button class="button" on:click="{() => push('/platzreife')}">
                  <span>Zur Übersicht</span>
                </button>
              </div>
            </article>
          </div>
        {:else}
          <h2 class="subtitle has-text-centered">Hier die Fragen dazu:</h2>
        {/if}

        {#if !examProgressData || (examProgressData && examProgressData[ch.slug] == false)}
          <div class="columns">
            <div
              class="questionaire column is-three-fifths-tablet is-offset-one-fifth-tablet"
            >
              {#if questionsLoading}
                <div
                  class="has-background-info-light has-text-info p-3 pl-4 has-text-left"
                >
                  Fragen werden geladen ..
                </div>
              {/if}

              {#if !questionsLoading && questionsData && !questionsData.length}
                <div
                  class="has-background-danger-light has-text-danger p-3 pl-4 has-text-left"
                >
                  Es sind noch keine Fragen im System hinterlegt.
                </div>
              {/if}

              {#if questionsData && !allAnswered}
                <div class="tabs is-default mb-6">
                  <ul>
                    <!-- <li class="is-text-bold pr-3">Zur Frage</li> -->
                    {#each questionsData as q, index}
                      <li class="{activeQuestion == index ? 'is-active' : ''}">
                        <a
                          on:click="{() => (activeQuestion = index)}"
                          class="
                {q.fixated && q.status && 'has-background-success-light'}
                {q.fixated && !q.status && 'has-background-danger-light'}
                {activeQuestion != index && !q.fixated && q.status !== undefined && 'has-background-warning-light'}"
                        >{index + 1}</a>
                      </li>
                    {/each}
                  </ul>
                </div>

                {#each questionsData as q, index}
                  {#if activeQuestion == index}
                    <div class="question" data-tab-index="{index}">
                      <h3 class="title is-4">
                        <span class="has-text-grey">Frage:</span>
                        {q.frage}
                        {#if q.fixated}
                          {#if q.status}
                            <span
                              title="Falsch beantwortet"
                              class="tag is-success"
                            >Richtig beantwortet</span>
                          {/if}
                          {#if !q.status}
                            <span
                              title="Richtig beantwortet"
                              class="tag is-danger"
                            >Falsch beantwortet</span>
                          {/if}
                        {:else if q.status === false || q.status === true}
                          <span
                            title="Nicht gespeichert"
                            class="tag is-light"
                          >Antwort noch nicht gespeichert</span>
                        {/if}
                      </h3>
                      <h3 class="title is-4">
                        <span
                          class="has-text-grey"
                        >{q.fixated ? 'Deine Antworten:' : getReadableSolutionsCount(q) + ' Antworten sind richtig:'}</span>
                      </h3>
                      <div class="answers control">
                        {#each q.answers as answer, aIndex}
                          <label class="answer-label is-size-5 mb-3">
                            <div>
                              <input
                                type="checkbox"
                                name="answer_{aIndex}"
                                class="answer-checkbox{(isDemo || isDev) && answer.solution ? ' answer-solution' : ''}"
                                bind:group="{selectedAnswers[index]}"
                                value="{aIndex}"
                                disabled="{q.fixated}"
                              />
                            </div>
                            <span
                              class="answer-label-text"
                            >{answer.answer}</span>
                          </label>
                        {/each}
                      </div>
                    </div>

                    <div class="has-text-left mt-5 mb-3">
                      <button
                        class="button {!q.fixated ? 'is-success' : 'is-light'} mt-5 mb-3"
                        on:click="{() => fixateAnswer(q, index)}"
                        disabled="{q.fixated || !selectedAnswers[index].length}"
                      >Antwort festlegen</button>
                    </div>
                  {/if}
                {/each}
              {/if}
            </div>
          </div>
        {/if}
      </div>
    </div>
  </section>
{/if}

<script>
import { onMount } from "svelte";
import * as animateScroll from "svelte-scrollto";
import {
  questions,
  currentChapter,
  userProgress,
  chapters,
  chapterSwitched,
  examProgress,
} from "./stores";
import { authSvc, chaptersSvc, demoSvc, examSvc } from "./services";
import ChapterNav from "./ChapterNav.svelte";
import { push } from "svelte-spa-router";
import { progressSvc } from "./services/progress.service";

export let params = {};

let questionsData,
  questionsLoading,
  activeQuestion = 0,
  allAnswered,
  allRulesRead,
  examProgressData,
  ch,
  chs,
  isDemo,
  isDev,
  questionsFetched,
  selectedAnswers = {},
  videoPlayed;

const finishedContinue = (slug) => {
  animateScroll.scrollTo({
    element: ".nav-chapters",
    offset: -100,
    duration: 250,
  });
  if (slug) {
    push("/platzreife/" + slug);
  } else {
    push("/platzreife/" + ch.slug + "/beantwortet");
  }
};

const getReadableSolutionsCount = (q) => {
  try {
    const count = q.answers.filter((a) => a.solution).length;
    switch (count) {
      case 2:
        return "Zwei";
      case 3:
        return "Drei";
      case 4:
        return "Vier";
      case 5:
        return "Fünf";
      default:
        return count;
    }
  } catch (err) {
    console.error("getReadableSolutionsCount error", err.message, { q });
    airbrake.notify(err);
  }
};

const fixateAnswer = (q, index) => {
  if (!q.fixated) {
    examSvc.fixateAnswer(index, selectedAnswers);
    allAnswered = progressSvc.allQuestionsAnswered();
  }

  if (allAnswered) {
    examSvc.updateChapter();
    finishedContinue();
  } else {
    // still in progress of answering
    activeQuestion = index + 1;
  }
};

const resetComponent = () => {
  questionsData = undefined;
  questionsFetched = undefined;
  activeQuestion = 0;
  selectedAnswers = {};
};

const setData = () => {
  if (!ch || !chs) {
    return;
  }

  allRulesRead = progressSvc.hasAllRulesRead();
  videoPlayed = progressSvc.hasVideoPlayed();

  if (!questionsData && !questionsFetched) {
    questionsFetched = true;
    // load initial questionsData
    if (demoSvc.isDemoInstance()) {
      questions.set(demoSvc.getQuestions());
      console.info("Activated Demo answer helper");
      isDemo = true;
    } else {
      setTimeout(() => {
        if (questionsLoading !== false) {
          questionsLoading = true;
        }
      }, 250);

      authSvc.setUserQuestions(ch.slug);
    }
    if (window.location.href.indexOf("golfclub-musterstadt") !== -1) {
      console.info("Activated Demo answer helper");
      isDemo = true;
    }
    if (window.location.href.indexOf("be-golf.test") !== -1) {
      console.info("Activated Dev answer helper");
      isDev = true;
    }
  }
};

onMount(() => {
  questions.subscribe((qData) => {
    if (qData == undefined) {
      return;
    }
    questionsLoading = false;
    questionsData = qData;
    for (let i = 0; i < questionsData.length; i++) {
      selectedAnswers[i] = questionsData[i].answerIndexes || [];
    }
  });

  chapterSwitched.subscribe(resetComponent);

  currentChapter.subscribe((data) => {
    if (data == undefined) {
      return;
    }
    ch = data;
    setData();
  });

  chapters.subscribe((data) => {
    chs = data;
    setData();
  });

  userProgress.subscribe((_) => setData());

  examProgress.subscribe((data) => (examProgressData = data));
});
</script>

<style type="text/scss">
// .section {
//   border: 1px dashed #ebebeb;
// }

.answer-label {
  display: flex;
  cursor: pointer;
  margin-bottom: 25px;
  &:disabled {
    cursor: no-drop;
  }
}
.answer-label > div {
  display: inline-block;
}
.answer-label-text {
  display: inline-block;
  line-height: 25px;
  vertical-align: middle;
}
.answer-checkbox {
  height: 25px;
  width: 25px;
  vertical-align: middle;
  margin-right: 15px;
  position: relative;
}
.answer-solution::before {
  border-left: 4px solid #63cb63;
  content: "";
  display: block;
  position: absolute;
  left: -8px;
  top: 0px;
  bottom: 0px;
  border-radius: 2px;
}
.button {
  font-weight: 700;
}

.chapter-text,
.questionaire {
  transition: all 0.3s ease;
  position: relative;
}
.disabled-notice {
  display: none;
}
.disabled {
  .chapter-text,
  .questionaire {
    pointer-events: none;
    opacity: 0.2;
    filter: blur(3px);
    max-height: 500px;
    overflow: hidden;
  }
  .disabled-notice {
    display: block;
  }
}
</style>
